import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

export default function PolitiqueConfidentialite() {
  return (
    <main>
      <Navbar />
      <article className="pt-28 pb-20 md:pb-28 px-6 md:px-10">
        <div className="max-w-2xl mx-auto">
          {/* Header */}
          <header className="mb-12 md:mb-16">
            <span className="block text-xs font-medium tracking-[0.3em] text-stone-400 uppercase mb-4">Légal</span>
            <h1 className="font-serif-display text-4xl md:text-5xl font-bold text-stone-900 leading-tight">
              Politique de confidentialité
            </h1>
          </header>

          {/* Company info block */}
          <div className="bg-stone-50 rounded-2xl p-6 md:p-8 mb-12">
            <h2 className="text-sm font-semibold text-stone-500 uppercase tracking-widest mb-4" id="responsable">
              <a href="#responsable">Responsable du traitement</a>
            </h2>
            <dl className="flex flex-col gap-2 text-sm text-stone-700">
              <div><dt className="inline font-medium">Responsable&nbsp;:</dt> <dd className="inline">Dawid Kurta – KURTA</dd></div>
              <div><dt className="inline font-medium">Adresse&nbsp;:</dt> <dd className="inline">2 Rue Pelleport, 33800 Bordeaux, France</dd></div>
              <div><dt className="inline font-medium">Email&nbsp;:</dt> <dd className="inline"><a href="mailto:daw1dkurta@inbox.eu" className="hover:text-stone-900 underline">daw1dkurta@inbox.eu</a></dd></div>
            </dl>
          </div>

          {/* Sections */}
          <div className="flex flex-col gap-10 text-stone-600">
            <section>
              <h2 className="text-xl font-bold text-stone-900 mb-3" id="donnees-collectees">
                <a href="#donnees-collectees">1. Données collectées</a>
              </h2>
              <p className="text-base leading-[1.8] mb-4">
                Ce site peut collecter, via le formulaire de contact, les données personnelles suivantes&nbsp;:
              </p>
              <ul className="flex flex-col gap-2 pl-4">
                {['Nom', 'Adresse email', 'Numéro de téléphone', 'Description du projet (message)'].map((item) => (
                  <li key={item} className="flex items-start gap-2 text-sm">
                    <span className="mt-2 w-1 h-1 rounded-full bg-stone-400 flex-shrink-0" />
                    {item}
                  </li>
                ))}
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-bold text-stone-900 mb-3" id="finalite">
                <a href="#finalite">2. Finalité du traitement</a>
              </h2>
              <p className="text-base leading-[1.8]">
                Les données personnelles collectées sont utilisées uniquement pour répondre aux demandes de contact et de projet adressées à KURTA. Aucune donnée n&apos;est utilisée à des fins commerciales sans votre consentement préalable.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-stone-900 mb-3" id="partage">
                <a href="#partage">3. Partage des données</a>
              </h2>
              <p className="text-base leading-[1.8]">
                Les données collectées ne sont <strong>ni vendues, ni cédées, ni partagées</strong> avec des tiers à des fins commerciales. Elles restent strictement confidentielles et sont utilisées exclusivement dans le cadre de la relation avec KURTA.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-stone-900 mb-3" id="conservation">
                <a href="#conservation">4. Durée de conservation</a>
              </h2>
              <p className="text-base leading-[1.8]">
                Les données sont conservées pour la durée nécessaire au traitement de votre demande, et supprimées dès que cette finalité est atteinte, conformément à la réglementation en vigueur (RGPD).
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-stone-900 mb-3" id="droits">
                <a href="#droits">5. Vos droits</a>
              </h2>
              <p className="text-base leading-[1.8]">
                Conformément au Règlement Général sur la Protection des Données (RGPD), vous disposez d&apos;un droit d&apos;accès, de rectification, d&apos;effacement et d&apos;opposition au traitement de vos données. Pour exercer ces droits, contactez-nous à&nbsp;:{' '}
                <a href="mailto:daw1dkurta@inbox.eu" className="text-stone-900 underline hover:no-underline">
                  daw1dkurta@inbox.eu
                </a>
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-stone-900 mb-3" id="cookies">
                <a href="#cookies">6. Cookies</a>
              </h2>
              <p className="text-base leading-[1.8]">
                Ce site n&apos;utilise pas de cookies de traçage ou de profilage. Des cookies techniques essentiels au bon fonctionnement du site peuvent être utilisés.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-stone-900 mb-3" id="contact-rgpd">
                <a href="#contact-rgpd">7. Contact RGPD</a>
              </h2>
              <p className="text-base leading-[1.8]">
                Pour toute question relative à la protection de vos données, contactez&nbsp;:{' '}
                <a href="mailto:daw1dkurta@inbox.eu" className="text-stone-900 underline hover:no-underline">
                  daw1dkurta@inbox.eu
                </a>
              </p>
            </section>
          </div>

          <p className="text-xs text-stone-400 mt-12">
            Dernière mise à jour&nbsp;: mars 2026
          </p>
        </div>
      </article>
      <Footer />
    </main>
  );
}